/**
 * Sample store data.
 *
 * This is placeholder data for development. In production this will be replaced
 * by a real data source (Shopify metaobjects, a JSON feed, an API, etc.).
 * The store locator only depends on the *shape* of these objects, so swapping
 * the source later is a drop-in change as long as the fields below are provided.
 *
 * Field reference:
 *   id        - unique string, used to link list rows <-> map markers
 *   name      - store display name
 *   address   - full street address (single line)
 *   city, state, zip
 *   phone     - display phone (tel: link is derived from this)
 *   lat, lng  - coordinates (required for the map)
 *   type      - category slug, must match a key in STORE_LOCATOR_CATEGORIES
 *   hours     - optional short "open" string
 *   website   - optional URL
 *   products  - optional array of product names carried at this location
 */
/**
 * Category filter chips.
 *
 * The KEY is the canonical `type` value — it must match the `type` column in the
 * master Google Sheet (and what the proxy maps VIP/sheet rows to). Changing a
 * key means re-typing the sheet.
 *
 * The `label` is display-only — rename freely without touching any data. Labels
 * are kept short so all three chips fit on one row in a narrow theme column;
 * they wrap gracefully if you lengthen them.
 */
window.STORE_LOCATOR_CATEGORIES = {
  retail: { label: 'Retail', icon: 'store' },
  bar: { label: 'Bars', icon: 'glass' },
  dispensary: { label: 'Dispensaries', icon: 'cannabis' },
};

window.STORE_LOCATOR_DATA = [
  {
    id: 'loc-001',
    name: '5 Brothers of 47th Food',
    address: '689 10th Ave',
    city: 'New York',
    state: 'NY',
    zip: '10019',
    phone: '(212) 397-3733',
    lat: 40.7625,
    lng: -73.9915,
    type: 'retail',
    hours: 'Open until 11 PM',
    products: [
      'Hi Boy (5mg THC) — Lemon Lavender',
      'Hi Boy (5mg THC) — Ginger Lemongrass',
    ],
  },
  {
    id: 'loc-002',
    name: 'Farmers Cafe & Market',
    address: '515 W 36th St',
    city: 'New York',
    state: 'NY',
    zip: '10018',
    phone: '(212) 510-7791',
    lat: 40.7554,
    lng: -73.9971,
    type: 'retail',
    hours: 'Open until 9 PM',
    products: [
      'Hi Boy (5mg THC) — Lemon Lavender',
      'Hi Boy (5mg THC) — Ginger Lemongrass',
      'Hi Boy (5mg THC) — Grapefruit Rosemary',
      'Hi Boy (5mg THC) — Yuzu Elderflower',
    ],
  },
  {
    id: 'loc-003',
    name: 'Food Emporium',
    address: '452 W 43rd St',
    city: 'New York',
    state: 'NY',
    zip: '10036',
    phone: '(212) 714-1414',
    lat: 40.7596,
    lng: -73.9927,
    type: 'retail',
    hours: 'Open 24 hours',
    products: [
      'Hi Boy (5mg THC) — Lemon Lavender',
      'Hi Boy (5mg THC) — Ginger Lemongrass',
      'Hi Boy (5mg THC) — Grapefruit Rosemary',
      'Hi Boy (10mg THC) — Black Cherry',
    ],
  },
  {
    id: 'loc-004',
    name: 'S & A Gourmet Deli',
    address: '240 8th Ave',
    city: 'New York',
    state: 'NY',
    zip: '10011',
    phone: '(646) 755-8822',
    lat: 40.7449,
    lng: -73.9979,
    type: 'retail',
    hours: 'Open until 12 AM',
    products: ['Hi Boy (5mg THC) — Lemon Lavender'],
  },
  {
    id: 'loc-005',
    name: 'The Chelsea Tavern',
    address: '198 9th Ave',
    city: 'New York',
    state: 'NY',
    zip: '10011',
    phone: '(212) 620-0900',
    lat: 40.7461,
    lng: -74.0016,
    type: 'bar',
    hours: 'Open until 2 AM',
    products: [
      'Hi Boy (5mg THC) — Grapefruit Rosemary',
      'Hi Boy (10mg THC) — Black Cherry',
    ],
  },
  {
    id: 'loc-006',
    name: 'East Village Social',
    address: '126 St Marks Pl',
    city: 'New York',
    state: 'NY',
    zip: '10009',
    phone: '(212) 777-3400',
    lat: 40.7274,
    lng: -73.9835,
    type: 'bar',
    hours: 'Open until 1 AM',
    products: [
      'Hi Boy (5mg THC) — Yuzu Elderflower',
      'Hi Boy (10mg THC) — Black Cherry',
    ],
  },
  {
    id: 'loc-007',
    name: 'Union Square Greenmarket Grocer',
    address: '4 Irving Pl',
    city: 'New York',
    state: 'NY',
    zip: '10003',
    phone: '(212) 353-9090',
    lat: 40.7359,
    lng: -73.9887,
    type: 'retail',
    hours: 'Open until 10 PM',
    products: [
      'Hi Boy (5mg THC) — Lemon Lavender',
      'Hi Boy (5mg THC) — Yuzu Elderflower',
    ],
  },
  {
    id: 'loc-008',
    name: 'SoHo Provisions',
    address: '110 Thompson St',
    city: 'New York',
    state: 'NY',
    zip: '10012',
    phone: '(212) 941-7900',
    lat: 40.7256,
    lng: -74.0027,
    type: 'retail',
    hours: 'Open until 11 PM',
    products: [
      'Hi Boy (5mg THC) — Ginger Lemongrass',
      'Hi Boy (5mg THC) — Grapefruit Rosemary',
    ],
  },
  {
    id: 'loc-009',
    name: 'Greenpoint Beer & Bottle',
    address: '167 Franklin St',
    city: 'Brooklyn',
    state: 'NY',
    zip: '11222',
    phone: '(718) 349-2337',
    lat: 40.7305,
    lng: -73.9575,
    type: 'bar',
    hours: 'Open until 12 AM',
    products: [
      'Hi Boy (5mg THC) — Lemon Lavender',
      'Hi Boy (10mg THC) — Black Cherry',
    ],
  },
  {
    id: 'loc-010',
    name: 'Long Island City Market',
    address: '47-30 Vernon Blvd',
    city: 'Long Island City',
    state: 'NY',
    zip: '11101',
    phone: '(718) 361-4400',
    lat: 40.7447,
    lng: -73.9541,
    type: 'retail',
    hours: 'Open until 10 PM',
    products: ['Hi Boy (5mg THC) — Ginger Lemongrass'],
  },
  {
    id: 'loc-011',
    name: 'Williamsburg Corner Deli',
    address: '184 Bedford Ave',
    city: 'Brooklyn',
    state: 'NY',
    zip: '11249',
    phone: '(718) 302-5100',
    lat: 40.7178,
    lng: -73.9571,
    type: 'retail',
    hours: 'Open 24 hours',
    products: [
      'Hi Boy (5mg THC) — Lemon Lavender',
      'Hi Boy (5mg THC) — Grapefruit Rosemary',
      'Hi Boy (5mg THC) — Yuzu Elderflower',
    ],
  },
  {
    id: 'loc-012',
    name: 'Hoboken Riverside Grocer',
    address: '90 Hudson St',
    city: 'Hoboken',
    state: 'NJ',
    zip: '07030',
    phone: '(201) 610-9090',
    lat: 40.7361,
    lng: -74.0287,
    type: 'retail',
    hours: 'Open until 11 PM',
    products: ['Hi Boy (5mg THC) — Lemon Lavender'],
  },
  {
    id: 'loc-013',
    name: 'Union Square Cannabis Co.',
    address: '32 Union Square E',
    city: 'New York',
    state: 'NY',
    zip: '10003',
    phone: '(212) 555-0177',
    lat: 40.7359,
    lng: -73.9903,
    type: 'dispensary',
    hours: 'Daily 10 AM - 9 PM',
    products: [
      'Cann (2mg THC) — Grapefruit Rosemary',
      'Cann (2mg THC) — Yuzu Elderflower',
    ],
  },
  {
    id: 'loc-014',
    name: 'Brooklyn Green Room',
    address: '88 Berry St',
    city: 'Brooklyn',
    state: 'NY',
    zip: '11249',
    phone: '(718) 555-0198',
    lat: 40.7191,
    lng: -73.9625,
    type: 'dispensary',
    hours: 'Daily 11 AM - 10 PM',
    products: ['Hi Boy (10mg THC) — Black Cherry'],
  },
];
